module.exports = {"sewingpattern":{"id":"sewingpattern","title":"Schnitt","selectedValues":{"Lieferzeit":"verschickt in 3-5 Tagen","Lieferumfang":"Mehrgrößen-Papierschnitt ohne Stoff"},"productData":{"processingtime":"verschickt in 3-5 Tagen","delivery":"Mehrgrößen-Papierschnitt ohne Stoff"}},"fabric":{"id":"fabric","title":"Stoff","selectedValues":{"Lieferumfang":"Stoff ohne Mehrgrößen-Papierschnitt"},"productData":{"delivery":"Stoff ohne Mehrgrößen-Papierschnitt"}},"schnoff":{"id":"schnoff","title":"Schnitt + Stoff","selectedValues":{},"productData":{}}}


//////////////////
// WEBPACK FOOTER
// ./src/data/products/de-DE.json
// module id = Pska
// module chunks = 58